import 'angular:locale/data:en';
import './apps/tenant-manager/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
